<template>
    <div class="recover">
        <template v-if="!submitted">
            <header class="recover__head">
                <h1 class="adm-title">Recuperar contraseña</h1>
                <p class="adm-muted">
                    Ingresa tu correo y te enviaremos un enlace para restablecerla.
                </p>
            </header>

            <form class="recover__form" @submit.prevent="sendRequest">
                <AdmField
                    v-model="email"
                    label="Correo electrónico"
                    type="email"
                    placeholder="tu@correo.com"
                    autocomplete="email"
                    required
                />

                <p v-if="error" class="recover__error adm-tone-danger" role="alert">
                    {{ error }}
                </p>

                <AdmButton type="submit" :loading="loading" block>
                    {{ loading ? 'Enviando…' : 'Enviar enlace' }}
                </AdmButton>
            </form>
        </template>

        <div v-else class="recover__done">
            <span class="recover__icon adm-tone-ok"><MailCheck :size="26" /></span>
            <h1 class="adm-title">Revisa tu correo</h1>
            <p class="adm-muted">{{ confirmationMessage }}</p>
            <p class="adm-muted">
                Si no lo ves en la bandeja de entrada, revisa también la carpeta de spam.
            </p>
        </div>

        <router-link to="/login" class="recover__back">Volver al inicio de sesión</router-link>
    </div>
</template>

<script>
/**
 * Solicitud de recuperación — migrada en la adenda del 27/09/2026.
 *
 * El mensaje de confirmación del servidor es deliberadamente neutro ("si el
 * correo existe, recibirás un enlace"): no confirma si la cuenta está o no
 * registrada. Esa respuesta se conserva tal cual.
 */
import { MailCheck } from 'lucide-vue-next';
import { requestPasswordReset } from '@/services/authService.js';
import AdmField from '@/components/Admin/ui/AdmField.vue';
import AdmButton from '@/components/Admin/ui/AdmButton.vue';

export default {
    name: 'RecoverRequestPage',
    components: { AdmField, AdmButton, MailCheck },
    data() {
        return {
            email: '',
            loading: false,
            submitted: false,
            confirmationMessage: '',
            error: '',
        };
    },
    methods: {
        async sendRequest() {
            this.error = '';
            this.loading = true;
            const { message, error } = await requestPasswordReset(this.email.trim().toLowerCase());
            this.loading = false;

            if (error) {
                this.error = error;
                return;
            }
            this.confirmationMessage = message;
            this.submitted = true;
        },
    },
};
</script>

<style scoped>
.recover {
    display: flex;
    flex-direction: column;
    gap: var(--adm-gap-lg);
}

.recover__head { text-align: center; }
.recover__head .adm-muted { margin: 0.35rem 0 0 0; }

.recover__form {
    display: flex;
    flex-direction: column;
    gap: var(--adm-gap);
}

.recover__error {
    margin: 0;
    padding: 0.6rem 0.75rem;
    border-radius: var(--adm-radius-sm);
    font-size: var(--adm-font-sm);
    line-height: 1.4;
}

.recover__done {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 0.5rem;
    text-align: center;
}

.recover__done .adm-muted { margin: 0; }

.recover__icon {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 52px;
    height: 52px;
    margin-bottom: 0.25rem;
    border-radius: 50%;
}

.recover__back {
    align-self: center;
    font-family: var(--font-body);
    font-size: var(--adm-font-sm);
    color: var(--color-text);
    text-decoration: none;
    border-bottom: 1px solid transparent;
}

.recover__back:hover {
    color: var(--color-brand);
    border-bottom-color: var(--color-brand);
}
</style>
